import {
  ReactNode,
  createContext,
  createElement,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

interface LoaderContextValue {
  isLoading: boolean;
  setLoading: (value: boolean) => void;
}

const LoaderContext = createContext<LoaderContextValue>({
  isLoading: false,
  setLoading: () => {},
});

export const LoaderProvider = ({ children }: { children: ReactNode }) => {
  const [isLoading, setLoading] = useState(false);
  const value = useMemo(() => ({ isLoading, setLoading }), [isLoading]);

  return createElement(LoaderContext.Provider, { value }, children);
};

export const useLoader = (show: boolean) => {
  const { setLoading } = useContext(LoaderContext);

  useEffect(() => {
    setLoading(show);
  }, [show, setLoading]);
};

export const useLoaderState = () => useContext(LoaderContext);
